import React from "react";
import { useUser } from "@clerk/clerk-react";
import { useUserRole, getUserType, dateFormat } from "../../../utils/helperMethods";

const Segment = ({ label, value }) => (
  <span className="text-sm text-gray-700">
    <span className="font-medium text-gray-900">{label}:</span>{" "}
    <span className="font-semibold text-gray-900">{value}</span>
  </span>
);

const VqqStatsBar = ({ totalQuestions, approvedCount, completeCount, approvedAt, completedAt }) => {
  const { user } = useUser();
  const role = useUserRole();
  const subRoles = user?.publicMetadata?.sub_role ?? [];
  const userType = getUserType(role, subRoles);
  const showVendorCounts = userType === "vendor";

  const totalLabel = totalQuestions === 1 ? "question" : "questions";

  return (
    <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-sm text-gray-700">
      <span className="text-gray-700">
        <span className="font-semibold text-gray-900">{totalQuestions}</span> {totalLabel}
      </span>

      {showVendorCounts && (
        <>
          <span className="text-gray-300">·</span>
          <Segment label="Draft" value={0} />
        </>
      )}

      {showVendorCounts && (
        <>
          <span className="text-gray-300">·</span>
          <Segment label="Approved" value={approvedCount} />
          {approvedAt ? (
            <>
              <span className="text-gray-300">·</span>
              <Segment label="Approved on" value={dateFormat(approvedAt)} />
            </>
          ) : null}
        </>
      )}

      <span className="text-gray-300">·</span>
      <span className="inline-flex items-center gap-1.5 text-sm text-gray-700">
        <span
          className="inline-block w-2 h-2 rounded-full bg-indigo-500"
          aria-hidden="true"
        />
        <span className="font-medium text-gray-900">Complete:</span>
        <span className="font-semibold text-gray-900">{completeCount}</span>
      </span>

      {completedAt ? (
        <>
          <span className="text-gray-300">·</span>
          <Segment label="Completed" value={dateFormat(completedAt)} />
        </>
      ) : null}
    </div>
  );
};

export default VqqStatsBar;
